import { reactive } from 'vue'
import type { Appointment, AppointmentStatus, AppointmentType } from '@/types'

export interface AppointmentsState {
  appointments: Appointment[]
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    status: AppointmentStatus | ''
    type: AppointmentType | ''
    organizationId: string
  }
}

export const getInitialState = (): AppointmentsState => ({
  appointments: [],
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: '',
    type: '',
    organizationId: '',
  },
})

export const createState = (): AppointmentsState => {
  return reactive<AppointmentsState>(getInitialState())
}

export const resetState = (state: AppointmentsState): void => {
  const initial = getInitialState()
  state.appointments = initial.appointments
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
